import { debounce } from "utils";

class SubCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector("[data-sub-container]");
    this.prev = this.querySelector("[data-sub-prev]");
    this.next = this.querySelector("[data-sub-next]");
    this.navigation = this.querySelector(".sub-collections__navigation");

    if (!this.container || !this.prev || !this.next) return;

    this.prev.addEventListener("click", () => this.scroll("prev"));
    this.next.addEventListener("click", () => this.scroll("next"));
    this.container.addEventListener(
      "scroll",
      debounce(this.updateNavVisibility.bind(this), 50)
    );
    window.addEventListener(
      "resize",
      debounce(this.updateNavVisibility.bind(this), 50)
    );
    this.updateNavVisibility();
  }

  scroll(direction) {
    const { scrollLeft, clientWidth } = this.container;
    const left =
      direction === "prev"
        ? scrollLeft - clientWidth
        : scrollLeft + clientWidth;

    this.container.scroll({
      left: left,
      behavior: "smooth",
    });
  }

  updateNavVisibility() {
    if (!this.prev || !this.next || !this.container) return;

    const { scrollLeft, clientWidth, scrollWidth } = this.container;
    const canScroll = scrollWidth > clientWidth + 2;

    if (!canScroll) {
      this.prev.style.opacity = "0";
      this.prev.style.pointerEvents = "none";
      this.next.style.opacity = "0";
      this.next.style.pointerEvents = "none";
      return;
    }

    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

    this.prev.style.opacity = atStart ? "0" : "";
    this.prev.style.pointerEvents = atStart ? "none" : "";

    this.next.style.opacity = atEnd ? "0" : "";
    this.next.style.pointerEvents = atEnd ? "none" : "";
  }
}

customElements.define("sub-collections", SubCollections);
